import {
    CUSTOMER_SEARCH_REQUEST,
    CUSTOMER_SEARCH_SUCCESS,
    CUSTOMER_SEARCH_FAIL,
    CUSTOMER_SEARCH_RESET,
    GET_CUSTOMERS_REQUEST,
    GET_CUSTOMERS_SUCCESS,
    GET_CUSTOMERS_FAIL,
    CREATE_CUSTOMER_REQUEST,
    CREATE_CUSTOMER_SUCCESS,
    CREATE_CUSTOMER_FAIL,
    GET_CUSTOMER_REQUEST,
    GET_CUSTOMER_SUCCESS,
    GET_CUSTOMER_FAIL
} from '../constants/customerConstants';

export const customerSearchReducer = (state = {
    customerSearch: {}
}, action) => {
    switch (action.type) {
        case CUSTOMER_SEARCH_REQUEST:
            return { ...state, loading: true, error: null };
        case CUSTOMER_SEARCH_SUCCESS:
            return { ...state, loading: false, customerSearch: action.payload, error: null };
        case CUSTOMER_SEARCH_FAIL:
            return { ...state, loading: false, error: action.payload };
        case CUSTOMER_SEARCH_RESET:
            return { ...state, loading: false, customerSearch: {}, error: action.payload };
        default:
            return state;
    }
};


export const getAllCustomersReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_CUSTOMERS_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_CUSTOMERS_SUCCESS:
            return { ...state, loading: false, customers: action.payload, error: null };
        case GET_CUSTOMERS_FAIL:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};


export const createCustomerReducer = (state = {}, action) => {
    switch (action.type) {
        case CREATE_CUSTOMER_REQUEST:
            return { ...state, loading: true, error: null };
        case CREATE_CUSTOMER_SUCCESS:
            return { ...state, loading: false, createCustomer: action.payload, error: null };
        case CREATE_CUSTOMER_FAIL:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};


export const getCustomerReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_CUSTOMER_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_CUSTOMER_SUCCESS:
            return { ...state, loading: false, customer: action.payload, error: null };
        case GET_CUSTOMER_FAIL:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

